// extracted by mini-css-extract-plugin
module.exports = {"container":"brandLogo_container__eOEOX","logo":"brandLogo_logo__9qQcZ","logoText":"brandLogo_logoText__QC_Xg","semrushLogoText":"brandLogo_semrushLogoText__iF9eT"};